<template>
	<div :class="[isCollapse?'hideSidebar':'','home-container']">
		<!-- 侧边栏   -->
		<aside class="home-aside">
			<Logo :collapse="isCollapse"></Logo>
			<el-menu style="border: none;background-color:#ff9811;font-weight:bold;margin-top:-1px;" :unique-opened="true" :collapse="isCollapse" :collapse-transition="false"
				:default-active="activeIndex" router class="sidebarParent">
				<div>
					<sidebar-item v-for="route in menuList" :key="route.path" :item="route" :base-path="route.path" />
				</div>
			</el-menu>
			<div class="navber-item-hover" @click="tabIsCollapse">
				<i :class="isCollapse?'el-icon-s-home':'el-icon-s-fold'"></i>
			</div>
		</aside>
		<!-- 页面主题区域 -->
		<section :class="[tagsViewShow?'':'tags-show','main-container']">
			<!-- 头部区域 -->
			<header :class="[fixedHeader?'fixed-header':'','home-header']">
				<div class="heder-navber" style="background-color:#ff9811;">
					<div class="navber-item" v-show="!tagsViewShow">
						<el-breadcrumb separator="/">
							<breadcrumb-item></breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="navber-item-right">
						<screenfull></screenfull>
					</div>
					<div class="navber-item">
						<my-center></my-center>
					</div>
				</div>
				<div class="tags-view-container" v-if="tagsViewShow">
					<tags-view :openTab="openTab"></tags-view>
				</div>
			</header>
			<!-- 右侧页面主题 -->
			<main class="home-main">
				<!--vue路由的过渡动画  -->
				<transition name="fade" mode="out-in">
					<keep-alive :include="cachedViews">
						<!-- 路由视图 -->
						<router-view></router-view>
					</keep-alive>
				</transition>
			</main>
		</section>
	</div>
</template>

<script>
	import SidebarItem from '@/components/SidebarItem'
	import BreadcrumbItem from '@/components/BreadcrumbItem'
	import Screenfull from '@/components/Screenfull'
	import TagsView from '@/components/TagsView'
	import MyCenter from '@/components/MyCenter'
	import Logo from '@/components/Logo'
	export default {
		name: 'Home',
		components: {
			SidebarItem,
			BreadcrumbItem,
			Screenfull,
			TagsView,
			MyCenter,
			Logo
		},
		created() {
			this.getMenuList();
			this.addTags();
		},
		data() {
			return {
				//左侧菜单数据
				menuList: [],
				isCollapse: false,
			};
		},
		watch: {
			$route(to, from) {
				console.log(to); //点击 菜单 要跳转的路由
				//console.log(from); //当前路由，
				if (to.path === "/redirect") {
					return false;
				}
				//判断路由是否已经打开
				var flag = this.openTab.some(item => {
					if (item.name === to.name) {
						//已经打开的 ，将其置为active
						this.$store.commit('app/set_active_index', to.path)
						return true
					}
				})
				if (this.cachedViews.indexOf(to.name) == -1) {
					//未找到 就缓存 页面名字
					this.$store.commit('app/add_cachedViews', to.name)
				}

				if (!flag) {
					//未打开的，将其放入队列里
					this.$store.commit('app/add_tabs', {
						route: to.path,
						name: to.name,
						title: to.meta.title,
					});
					this.$store.commit('app/set_active_index', to.path);
				}
			}
		},
		computed: {
			cachedViews() {
				//由于目前 keep-alive 和 router-view 是强耦合的，而且查看文档和源码不难发现 keep-alive 的 include 默认是优先匹配组件的 name ，
				//所以在编写路由 router 和路由对应的 view component 的时候一定要确保 两者的 name 是完全一致的。
				//默认如果不写 name 就不会被缓存，
				//(切记 name 命名时候尽量保证唯一性 切记不要和某些组件的命名重复了，不然会递归引用最后内存溢出等问题)
				return this.$store.getters['app/cachedViews'];
			},
			openTab() {
				return this.$store.getters['app/openTab'];
			},
			activeIndex: {
				get() {
					return this.$store.state.app.activeIndex;
				},
				set(val) {
					this.$store.commit('app/set_active_index', val);
				}
			},
			fixedHeader() {
				return this.$store.state.settings.fixedHeader;
			},
			tagsViewShow() {
				return this.$store.state.settings.tagsViewShow;
			}
		},
		methods: {
			tabIsCollapse() { //左右收缩
				this.isCollapse = !this.isCollapse;
			},
			//刷新 加载刚刚打开的菜单
			addTags() {
				let activePath = this.$route;
				if (activePath.meta.title != '首页') {
					this.$store.commit('app/set_active_index', activePath.path)
					this.$store.commit('app/add_tabs', {
						title: activePath.meta.title,
						route: activePath.path,
						name: activePath.name
					});
				}
			},
			//获取左侧菜单
			getMenuList: async function() {
				let _this = this;
				let data = _this.$store.getters['permission/routes'];
				if (data.length > 0) {
					_this.menuList = data;
				} else {
					_this.$fail("该用户菜单为空");
				}
			},
			//左侧菜单折叠 和展开
			toggleCollaose() {
				this.isCollapse = !this.isCollapse;
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	.home-container {
		height: 100%;
		width: 100%;
	}

	.el-menu-item.is-active {
		color: #000!important;
	}

	.home-aside {
		overflow: hidden;
		box-sizing: border-box;
		background-color: rgb(84, 92, 100);
		border: none;
		transition: width .28s;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		width: 200px;
	}

	.sidebarParent {
		/*使滚动条超出当前元素的父元素边界，而父元素设置了overflow为hidden，使溢出内容隐藏，即隐藏了滚动条*/
		width: calc(100% + 20px);
		height: calc(100vh - 90px);
		box-sizing: content-box;
		/*兼容ie，使盒模型为w3c盒模型*/
		/*控制能沿y轴滚动*/
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.hideSidebar .navber-item-hover {
		align-items: center;
		padding: 0 12px;

		&:hover {
			background-color: #F0F0F0;
		}
	}

	.navber-item-hover {
		height: 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		cursor: pointer;
		padding: 0 12px;
		background-color: #ff9811;

		&:hover {
			background-color: #F0F0F0;
		}
	}

	.hideSidebar {
		.home-aside {
			width: 64px;
		}

		.main-container {
			margin-left: 64px;
		}

		.fixed-header {
			width: calc(100% - 64px);
		}
	}

	.main-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		margin-left: 200px;
		transition: margin-left .28s;
	}

	.home-header {
		background-color: #b3c0d1;
		color: #333;
		display: flex;
		justify-content: space-between;
		flex-direction: row;
		align-items: center;
		flex-direction: column;
		overflow: hidden;
		height: 84px;
		box-sizing: border-box;
	}

	.fixed-header {
		position: fixed;
		top: 0;
		right: 0;
		z-index: 9;
		width: calc(100% - 200px);
		transition: width 0.28s;
	}

	.fixed-header+.home-main {
		padding-top: 84px;
	}

	.tags-show>.home-header {
		height: 50px;
		box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
	}



	.tags-show>.home-main {
		min-height: calc(100vh - 50px);
	}

	.tags-show>.fixed-header+.home-main {
		padding-top: 50px;
	}

	.home-main {
		min-height: calc(100vh - 84px);
	}

	.heder-navber {
		height: 50px;
		overflow: hidden;
		position: relative;
		padding: 0 30px 0 10px;
		box-sizing: border-box;
		box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
		width: 100%;
		background-color: #fff;
		display: flex;
		flex-direction: row;
	}

	.navber-item {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		padding: 0 12px;
	}

	.navber-item-right {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		padding: 0 15px;
		margin-left: auto;
	}

	.el-breadcrumb {
		margin-bottom: 0;
	}

	.tags-view-container {
		height: 34px;
		width: 100%;
		display: flex;
		align-items: center;
		background: #fff;
		overflow-y: hidden;
		border-bottom: 1px solid #d8dce5;
	}

	/**
 * 路由动画
 */
	.fade-enter {
		opacity: 0;
	}

	.fade-leave {
		opacity: 1;
	}

	.fade-enter-active {
		transition: opacity .4s;
	}

	.fade-leave-active {
		opacity: 0;
		transition: opacity .4s;
	}
</style>
<style lang="scss">
	.table-edit-inputDate{
		.el-input__icon.el-icon-date{
			line-height: 28px!important;
		}
		.el-input__icon.el-icon-circle-close{
			line-height: 28px!important;
		}
		.el-input__icon
		.el-input__inner{
			padding-right: 5px;
			line-height: 28px;
		}
	}
</style>
